// extracted by mini-css-extract-plugin
export default {"root":"gkVXZ7_hYx"};